import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComprehensiveCoverService {

  public baseUrl = environment.apiUrl.concat('/api/comprehensive-motor');
  http = inject(HttpClient);

  fetchComprehensiveQuotations(status: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}?status=${status}`);
  }

  fetchSingleQuotation(quoteId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/${quoteId}`);
  }

  revokePolicy(body: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/revoke`, body);
  }

  getReports(startDate: string, endDate: string): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/api/report/motor-comprehensive?dateFrom=${startDate}&dateTo=${endDate}`, {});
  }
}
